export enum ProductType {
  UnknownProductType = 0,
  Explosif = 1,
  Detonator = 2,
  Bulk = 3,
  DetCord = 4,
  Cartridge = 5,
  Stemming = 6,
  Booster = 7,
}


